<template>
  <div :class="{ 'opacity-50 cursor-not-allowed': this.inProgress }">
    <div v-if="session.startup_application">
      <h1 class="text-bold text-blue mb-5">
        {{ $t("form.startupInformation") }}
      </h1>
      <h2
        class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b"
        v-if="session.session_name"
      >
        {{ session.session_name.label }}
      </h2>
      <div
        v-if="isSubmitted && this.errors == null"
        class="alert alert-success bg-green-light text-sm border border-green text-green px-4 py-3 rounded relative mb-4"
      >
        <p class="mb-0">
          <strong class="font-bold">{{ $t("form.sent") }}</strong>
        </p>
      </div>

      <div
        v-if="this.errors != null"
        class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
        role="alert"
      >
        <p class="mb-0">
          <strong class="font-bold">{{ $t("form.correctErrors") }}</strong>
        </p>
        <ul class="error-messages block sm:inline text-left p-0 list-reset">
          <li v-for="(error, index) in this.errors" :key="index">
            <span v-if="error"> {{ errorsTranslation(error[0]) }}</span>
          </li>
        </ul>
      </div>

      <form
        name="formStartupInformation"
        v-on:submit.prevent="startupInformationSave()"
        v-if="showForm"
      >
        <div
          class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide"
        >
          <div class="w-full relative px-4 py-2 lg:w-1/2 border-rr">
            <sp-dropzone
              theme="form"
              :required="true"
              id="logo"
              label="Logo"
              type="1"
              :url="url"
              :startupInfo="true"
              :vdropzonethumbnail="dropzoneSuccess"
              :vdropzonesuccess="dropzoneSuccess"
              :vdropzoneError="vdropzoneError"
              :vdropzone-removed-file="vdropzoneRemovedFile"
              :vdropzoneProcessing="vdropzoneProcessing"
              :maxFiles="maxFiles"
              :downloadFile="true"
              :question="form.logo"
              :isImage="true"
              acceptedFiles="image/*"
            >
            </sp-dropzone>
          </div>
          <div class="w-full relative px-4 py-2 lg:w-1/2">
            <div class="tip">
              <div
                class="flex items-center p-2"
              >
                <div class="w-1/6 xl:pl-3">
                  <i :class="iconInfo"></i>
                </div>
                <div class="w-5/6 text-grey-dark text-sm italic"><span v-html="tipContent"></span></div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide"
        >
          <div class="w-full relative px-4 py-2 lg:w-1/2 border-rr">
            <sp-input
              theme="form"
              :required="true"
              :name="'project_name'"
              v-model="form.project_name"
              :label="'Nom de la startup'"
              :disabled="false"
            >
            </sp-input>
          </div>
        </div>

        <!-- Industry -->
        <div
          class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide"
        >
          <div class="w-full relative px-4 py-2 lg:w-1/2 border-rr">
            <div class="block mb-4 text-blue text-2sm mb-4">
              <span>Industrie</span>
              <span class="obligatoire"> *</span>
            </div>
            <sp-select
              :selected="form.industry"
              theme="form"
              v-model="industry"
              :options="selectList"
              :name="'inputIndustrySelect'"
              :id="'inputIndustrySelect'"
              placeholder="Sélectionnez option"
              :disabled="false"
            ></sp-select>
          </div>
        </div>

        <!-- Sector -->

        <div
          class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide"
        >
          <div class="w-full relative px-4 py-2 lg:w-1/2 border-rr">
            <div class="block mb-4 text-blue text-2sm mb-4">
              <span>Secteur</span>
              <span class="obligatoire"> *</span>
            </div>
            <sp-select
              :selected="sector"
              theme="form"
              v-model="sector"
              :options="sectorSelectList"
              :name="'inputSectorSelect'"
              :id="'inputSectorSelect'"
              placeholder="Sélectionnez option"
              :disabled="false"
            ></sp-select>
          </div>
        </div>

        <div
          class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide"
        >
          <div class="w-full relative px-4 py-2 lg:w-1/2 border-rr">
            <sp-input
              theme="form"
              :name="'website'"
              v-model="form.website"
              :label="'Site web'"
              :disabled="false"
            >
            </sp-input>
          </div>
        </div>
        <div
          class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide"
        >
          <div class="w-full relative px-4 py-2 lg:w-1/2 border-rr">
            <sp-textarea
              :maxWords="50"
              theme="form"
              v-model="form.description_fr"
              :required="true"
              :name="'description_fr'"
              :id="'description_fr'"
              :label="'Description FR'"
              :disabled="false"
            ></sp-textarea>
          </div>
        </div>

        <div
          class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide"
        >
          <div class="w-full relative px-4 py-2 lg:w-1/2 border-rr">
            <sp-textarea
              :maxWords="50"
              theme="form"
              v-model="form.description_en"
              :required="true"
              :name="'description_en'"
              :id="'description_en'"
              :label="'Description EN'"
              :disabled="false"
            ></sp-textarea>
          </div>
        </div>

        <div
          class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide"
        >
          <div class="w-full relative px-4 py-2 lg:w-1/2 border-rr">
            <sp-table
              type="16"
              v-model="founders"
              :label="'Fondateurs'"
              :required="true"
              theme="form"
              :selected="founders"
              :disabled="form.is_first_submission ? true : false"
            ></sp-table>
          </div>
        </div>

        <!-- <div
          class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide"
        >
          <div class="w-full relative px-4 py-2 lg:w-1/2 border-rr">
            <sp-table-list
              type="17"
              v-model="founders"
              :label="'Fondateurs'"
              :required="true"
              theme="form"
              :selected="founders"
              :disabled="form.is_first_submission ? true : false"
            ></sp-table-list>
          </div>
        </div> -->

        <div
          class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide"
        >
          <div class="w-full relative px-4 py-2 lg:w-1/2 border-rr">
            <div class="block mb-4 text-blue text-2sm mb-4">
              <span
                >Voulez vous afficher vos informations de contact sur le
                site</span
              >
              <span class="obligatoire"> *</span>
            </div>
            <sp-radio
              theme="form"
              :name="'inputRadio'"
              :id="'radioYes'"
              :value="'yes'"
              v-model="radioChecked"
              :disabled="false"
              :readonly="false"
              >Oui</sp-radio
            >
            <sp-radio
              theme="form"
              :name="'inputRadio'"
              :id="'radioNo'"
              :value="'no'"
              v-model="radioChecked"
              :disabled="false"
              :readonly="false"
              >Non</sp-radio
            >
          </div>
        </div>

        <div v-if="radioChecked == 'yes'">
          <div
            class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide"
          >
            <div class="w-full relative px-4 py-2 lg:w-1/2 border-rr">
              <sp-input
                theme="form"
                :required="false"
                :name="'email'"
                v-model="form.email"
                :value="'email'"
                :label="'Email'"
                :disabled="false"
              >
              </sp-input>
            </div>
          </div>
          <div
            class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 parent-hide"
          >
            <div class="w-full relative px-4 py-2 lg:w-1/2 border-rr">
              <sp-input
                theme="form"
                :required="false"
                :name="'phone'"
                v-model="form.phone"
                :value="'phone'"
                :label="'Téléphone'"
                :disabled="false"
              >
              </sp-input>
            </div>
          </div>
        </div>

        <div
          v-if="!this.inProgress"
          class="flex items-center justify-end w-auto bg-white mt-4 sm:mt-8 p-4 sm:p-8 pb-2 -mx-3"
        >
          <sp-button theme="outline-blue" space="small" class="" type="submit"
            >{{ $t("form.send") }}
          </sp-button>
        </div>
      </form>
    </div>
  </div>
</template>

<style>
.border-rr:after {
  content: "";
  position: absolute;
  top: 0;
  right: -12px;
  width: 2px;
  height: 100%;
  background-image: linear-gradient(
    to bottom,
    rgba(210, 216, 224, 0),
    rgba(210, 216, 224, 0.28),
    rgba(210, 216, 224, 0.78),
    rgba(210, 216, 224, 0)
  );
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

@media screen and (max-width: 992px) {
  .border-rr:after {
    display: none;
  }
}
</style>

<script>
import { mapGetters, mapState } from "vuex";
import {
  STARTUP_INFORMATIONS_FORM_GET,
  STARTUP_INFORMATIONS_FORM_SAVE
} from "@/store/actions.type";
import QForm from "@/components/Candidat/QForm.vue";
import ButtonVue from "../../components/spKit/Button.vue";
import Input from "@/components/spKit/Input.vue";
import Textarea from "@/components/spKit/Textarea.vue";
import Checkbox from "@/components/spKit/Checkbox.vue";
import Radio from "@/components/spKit/Radio.vue";
import DropZoneVue from "@/components/spKit/DropZone.vue";
import UrlVue from "@/components/spKit/Url.vue";
import { API_URL } from "@/common/config";
const uploadURL = API_URL + "/documents/upload";
import SelectVue from "@/components/spKit/Select.vue";
import TableVue from "@/components/spKit/Table.vue";
import TableListVue from "@/components/spKit/Table-list.vue";
export default {
  name: "StartupInformationsForm",
  data() {
    return {
      inProgress: false,
      maxFiles: 1,
      isSubmitted: false,
      isLeader: true,
      delegation: null,
      url: uploadURL,
      radioChecked: "yes",
      founders: null,
      showForm: false,
      sectorSelectList: [],
      errors: null,
      tipContent: "Merci d'uploader un logo en png ou jpeg ayant la taille 88px x 88px sur un Fonds blanc à rajouter à droite du logo",
      iconInfo: "fa fa-info fa-2x inline-block w-8 h-8 text-center text-white text-base font-300 leading-loose rounded-full bg-blue-light",
      selectList: [
        {
          name: "Mobility",
          value: "Mobility",
          default: "0",
          inner_data: [
                "Transportation",
                "Logistics",
                "SpaceTech",
                "Maps",
                "Other"
            ]
        },
        {
          name: "HealthTech",
          value: "HealthTech",
          default: "0",
          inner_data: [
                "HealthTech",
                "Life sciences",
                "Pharma",
                "Biotech",
                "Other"
            ]
        },
        {
          name: "Security",
          value: "Security",
          default: "0",
          inner_data: [
                "CyberSecurity",
                "Security",
                "Other"
            ]
        },
        {
          name: "Fintech",
          value: "Fintech",
          default: "0",
          inner_data: [
                "InsuranceTech",
                "Banking services",
                "Cryptocurrency",
                "Payments",
                "Trading",
                "Other"
            ]
        },
        {
          name: "Ad Tech and Creative Tech",
          value: "Ad Tech and Creative Tech",
          default: "0",
          inner_data: [
                "Gaming",
                "Media",
                "Art",
                "AdTech",
                "Events",
                "Entertainment",
                "Others (mode, beauty..)"
            ]
        },
        {
          name: "Communication services",
          value: "Communication services",
          default: "0",
          inner_data:  [
                "Social platforms",
                "Messaging",
                "teleconference",
                "Marketplace / e-commerce",
                "Other"
            ]
        },
        {
          name: "Advanced Manufacturing & Robotics",
          value: "Advanced Manufacturing & Robotics",
          default: "0",
          inner_data: [
                "Manufacturing",
                "Industry",
                "Industry 4.0 solutions",
                "Robotics",
                "Other"
            ]
        },
        {
          name: "FoodTech & New Food",
          value: "FoodTech & New Food",
          default: "0",
          inner_data: [
                "FoodTech",
                "New Food",
                "Marketplace / e-commerce",
                "Other"
            ]
        },

        {
          name: "Real Estate Tech",
          value: "Real Estate Tech",
          default: "0",
          inner_data: [
                "Real Estate Tech",
                "PropTech",
                "Construction",
                "Marketplace / e-commerce",
                "Other"
            ]
        },
        {
          name: "Wellness",
          value: "Wellness",
          default: "0",
          inner_data: [
                "Sport",
                "Social Platform",
                "Marketplace / e-commerce",
                "Other"
            ]
        },
        {
          name: "TravelTech",
          value: "TravelTech",
          default: "0",
          inner_data: [
                "TravelTech",
                "Hebergement",
                "Marketplace / e-commerce",
                "Other"
            ]
        },
        {
          name: "EdTech",
          value: "EdTech",
          default: "0",
          inner_data: [
                "EdTech",
                "Learning",
                "Coaching",
                "Marketplace / e-commerce",
                "Other"
            ]
        },
        {
          name: "Agritech",
          value: "Agritech",
          default: "0",
          inner_data: [
                "Agritech",
                "Biotech",
                "Marketplace / e-commerce",
                "Other"
            ]
        },
        {
          name: "Business Software and services",
          value: "Business Software and services",
          default: "0",
          inner_data: [
                "RH",
                "Retail",
                "ERP",
                "Customer support",
                "Productivity",
                "Legal Tech",
                "Employment",
                "Accounting",
                "Marketing",
                "Websites and mobile apps",
                "Other"

            ]
        },
        {
          name: "Environment",
          value: "Environment",
          default: "0",
          inner_data: [
                "CleanTech",
                "Energy",
                "Water",
                "Smart city",
                "Agriculture",
                "Other"
            ]
        },
        {
          name: "Social Business",
          value: "Social Business",
          default: "0",
          inner_data: ["Social Business"]
        },
        {
          name: "Commerce and shopping",
          value: "Commerce and shopping",
          default: "0",
          inner_data: [
                "E-commerce",
                "Marketplace",
                "Auctions",
                "Classifieds",
                "Coupons",
                "Other"
            ]
        },
        {
          name: "Consumer products and services",
          value: "Consumer products and services",
          default: "0",
          inner_data: [
                "Electronics",
                "Smart Home",
                "Smart devices",
                "AR/VR devices",
                "Consumer Hardware",
                "IOT",
                "Other"
            ]
        }
      ],
      form: {
        app_id: null,
        logo: {
          content: []
        },
        project_name: null,
        industry: null,
        sector: null,
        website: null,
        description_fr: null,
        description_en: null,
        founders: null,
        email: null,
        phone: null,
        show: null,
        is_first_submission: null
      },
      industry: null,
      sector: null,
      valueChangedSelect: false,
      uploadResponse: []
    };
  },
  components: {
    "q-form": QForm,
    "sp-button": ButtonVue,
    "sp-input": Input,
    "sp-textarea": Textarea,
    "sp-checkbox": Checkbox,
    "sp-radio": Radio,
    "sp-dropzone": DropZoneVue,
    "sp-url": UrlVue,
    "sp-select": SelectVue,
    "sp-table": TableVue,
    "sp-table-list": TableListVue
  },
  methods: {
    getInnerSelectData(data) {
      let options = [];
      if (data.inner_data.length) {
        data.inner_data.forEach((e, k) => {
          options.push({
            name: e,
            value: k
          });
        });
      }
      this.change_options = options;
    },
    startupInformationSave() {
      let form = this.getForm();
      form.responses.uploadLogoResponse = this.uploadResponse;

      if (!this.inProgress) {
        this.$store
          .dispatch(STARTUP_INFORMATIONS_FORM_SAVE, {
            form: form,
            id: this.session.startup_application.id
          })
          .then(data => {
            window.scrollTo(0, 0);
            this.inProgress = true;
            this.errors = null;
            this.isSubmitted = true;
          })
          .catch(response => {
            window.scrollTo(0, 0);
            this.inProgress = false;
            this.errors = null;
            if (response) this.errors = response.data.meta.errors;
          });
      }
    },
    governoratechange(data) {
      this.delegation = data;
    },
    updateDisabled(val) {
      this.inProgress = val;
    },
    getForm() {
      this.form.industry = this.industry;
      this.form.sector = this.sector;
      this.form.founders = this.founders;
      this.form.show = this.radioChecked == "yes" ? true : false;

      let form = {
        app_id: this.form.app_id,
        responses: this.form
      };

      return form;
    },
    vdropzoneProcessing(file) {
      this.updateDisabled(true);
    },
    dropzoneSuccess(file, response) {
      if (!(this.uploadResponse instanceof Array)) {
        this.uploadResponse = [];
      }
      if (response) {
        this.uploadResponse.push(response.data.document.id);
        this.form.logo.content.push(response.data.document.id)
      }
      this.updateDisabled(false);
    },
    vdropzoneError(file, message) {
      this.updateDisabled(false);
      if (message.meta && message.meta.status == 400)
        this.uploadResponse.splice(-1, 1);
      this.$el.getElementsByClassName("dz-error-message")[0].innerHTML =
        "you cant upload this file";
    },
    vdropzoneRemovedFile(file, error, xhr) {
      this.uploadResponse = [];
      this.form.logo = [];
    },

    errorsTranslation(message) {
      if (message.includes("quand la valeur de show est true")) {
        message = message.replace("quand la valeur de show est true", "");
      }

      if (message.includes("project name")) {
        message = message.replace("project name", "Nom de la startup");
      }

      if (message.includes("industry")) {
        message = message.replace("industry", "Industrie");
      }

      if (message.includes("sector")) {
        message = message.replace("sector", "Secteur");
      }

      if (message.includes("website")) {
        message = message.replace("website", "Site web");
      }

      if (message.includes("founders")) {
        message = message.replace("founders", "Fondateurs");
      }

      return message;
    },
    fillForm(data) {
      this.form.app_id = data.data.startup.app_id;
      this.form.project_name = data.data.startup.project_name;
      this.form.industry = this.industry = data.data.startup.industry;
      this.form.sector = this.sector = data.data.startup.sector;
      this.form.website = data.data.startup.website;
      this.form.description_fr = data.data.startup.description_fr;
      this.form.description_en = data.data.startup.description_en;
      this.form.email = data.data.startup.email;
      this.form.phone = data.data.startup.phone;
      this.form.show = data.data.startup.show;
      this.form.is_first_submission = data.data.startup.is_first_submission;
      this.radioChecked = this.form.show ? "yes" : "no";
      if (data.data.startup.logo) {
        this.form.logo.content.push(data.data.startup.logo);
      }

      // Prevent user from editing
      if (data.data.startup.status == -1  || data.data.startup.status == 1) {
        this.inProgress = true;
      }

      // Founders list
      var arrayFounders = data.data.startup.founders.split("|");
      arrayFounders.pop();
      let arrayObjects = [];
      arrayFounders.forEach(element => {
        let obj = {
          full_name: element
        };
        arrayObjects.push(obj);
      });
      this.founders = JSON.stringify(arrayObjects);
      let options = [];
      Array.prototype.forEach.call(this.selectList, industry => {
        if (industry.name == this.industry) {
          industry.inner_data.forEach(element => {
            options.push({ name: element, value: element });
          });
        }
      });
      this.sectorSelectList = options;
      this.showForm = true;
      this.$Progress.finish();
    }
  },
  watch: {
    industry: function(val) {
      let options = [];
      Array.prototype.forEach.call(this.selectList, industry => {
        if (industry.name == val) {
          industry.inner_data.forEach(element => {
            options.push({ name: element, value: element });
          });
        }
      });

      // Keep selected sector value
      if (this.valueChangedSelect) {
        this.sector = null;
      } else {
        this.valueChangedSelect = true;
      }
      this.sectorSelectList = options;
    }
  },
  mounted() {
    if (
      (this.session &&
        this.session.startup_application &&
        this.session.startup_application.status == 0) ||
      this.StartupInformations == null
    ) {
      this.$router.push({ name: "home" });
    } else {
      this.$Progress.start();
      // Get startup informations form data
      this.$store
        .dispatch(STARTUP_INFORMATIONS_FORM_GET, this.$route.params.app_id)
        .then(data => {
          this.fillForm(data);
        })
        .catch(error => {
          this.$router.push({ name: "home" });
        });
    }
  },
  computed: {
    ...mapGetters(["session", "StartupInformations"])
  }
};
</script>
